export default {
  baseStyle: {
    borderRadius: 'lg',
    bg: 'primary.accent1',
  },
}
